var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-item',[_c('img',{staticClass:"img-content",attrs:{"src":require(`@/assets/product/${_vm.productName}.png`),"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }